import PropTypes from 'prop-types';
import React from 'react';
import { DynamicTable } from 'common/tables';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import _ from 'lodash';
import FilterBar from '../FilterBar';
import DashboardRowIcon from '../DashboardRowIcon';

function getColumns(sortConfig, setSortConfig) {
  return [
    {
      label: 'Client Name',
      sortColumn: 'requestor.full_name',
    },
    {
      label: 'Service Type',
      sortColumn: 'service_type.name',
    },
    {
      label: 'Date Received',
      type: 'date',
      sortColumn: 'created_at',
      sortBy: sortConfig?.sidx || 'created_at',
      sortDirection: sortConfig?.sord || 'asc',
      setSort: ({ sortBy, sortDirection }) => setSortConfig(sortBy, sortDirection),
    },
  ];
}

function AssistanceRequestsIndex(props) {
  const {
    paging,
    data,
    onNextClick,
    onPrevClick,
    isFetching,
    onCellClick,
    initialSort,
    fetchGroupsUsers,
    filters,
    onFiltersChange,
    showFilterDuration,
    addDateRangeFilter,
    sortConfig,
    setSort,
  } = props;

  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
        showFilterDuration={showFilterDuration}
        addDateRangeFilter={addDateRangeFilter}
        styles={{ filter: { marginTop: '10px' } }}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                caption="New assistance requests"
                id="new-assistance-requests-table"
                dataSet={data}
                onCellClick={onCellClick}
                initialSort={initialSort}
                columnLabels={getColumns(sortConfig, setSort)}
                emptyMessage="There are no assistance requests."
                rowIcon={DashboardRowIcon}
              />
            )
        }
      </div>
    </div>
  );
}

AssistanceRequestsIndex.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: shapes.paging,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  initialSort: PropTypes.object,
  fetchGroupsUsers: PropTypes.func.isRequired,
  filters: PropTypes.array,
  onFiltersChange: PropTypes.func,
  showFilterDuration: PropTypes.bool,
  addDateRangeFilter: PropTypes.bool,
  sortConfig: PropTypes.object,
  setSort: PropTypes.func,
};

AssistanceRequestsIndex.defaultProps = {
  showFilterDuration: true,
  addDateRangeFilter: false,
};

export default AssistanceRequestsIndex;
